function ApiRequestError({ error }) {
  return (
    <p>🔴 There was an error when performing the request to the server. Your session may have expired and, in that case, you will need to logout and login again. If that doesn't work, contact this site administrator.</p>
  )
}

export { ApiRequestError }
